// inbox.constants.ts
export const PAGE_DEFAULTS_PARAMS = {
  currentPage: 0,
  pageSize: 10,
  status: 'All',
  search: '',
  hasMoreData: true,
};
